import React, { useEffect } from "react";
import { Common } from "../Components/Canvas";
import close from "../images/close.png";

export default function BotRightMenu({ content, type }) {
  useEffect(() => {
    if (type === "canvases") {
      if (Common.background !== undefined) {
        let canvas_buttons = document.querySelectorAll(".canvasesButton");
        let buttons_array = Array.from(canvas_buttons);

        buttons_array[Common.background].classList.add("background_selected");
      }
      return;
    }

    if (Common.tape !== undefined) {
      let tapes_buttons = document.querySelectorAll(".tapesButton");
      let buttons_array = Array.from(tapes_buttons);

      buttons_array[Common.tape].classList.add("tape_selected");
    } else {
      let tape = document.querySelector(".tapesButton");

      if (tape) tape.classList.add("tape_selected");
    }
  });

  function highlightButton(ev) {
    if (ev.target.nodeName !== "IMG") return;

    if (type === "canvases") {
      let canvas_buttons = document.querySelectorAll(".canvasesButton");
      let buttons_array = Array.from(canvas_buttons);

      for (let button of canvas_buttons) {
        button.classList.remove("background_selected");
      }

      ev.target.parentNode.classList.add("background_selected");
      Common.background = buttons_array.indexOf(ev.target.parentNode);

      return;
    }

    let tapes_buttons = document.querySelectorAll(".tapesButton");
    let buttons_array = Array.from(tapes_buttons);

    for (let button of tapes_buttons) {
      button.classList.remove("tape_selected");
    }

    ev.target.parentNode.classList.add("tape_selected");
    Common.tape = buttons_array.indexOf(ev.target.parentNode);
  }

  return (
    <div
      className={
        !Common.mobile
          ? "rightMenuContainer"
          : "rightMenuContainer rightMenuContainerDevice"
      }
    >
      <div
        className={
          !Common.mobile
            ? "rightMenuBorder"
            : "rightMenuBorder rightMenuBorderDevice"
        }
        data-name={type}
        onClick={highlightButton}
      >
        {content}
      </div>
      <button className="canvasesClose">
        <img src={close} alt="" />
      </button>
    </div>
  );
}
